import transform from './transform';

(function () {
    var throttle = require('lodash/throttle');
    window.E3Swipe = {init: initSwipe, destroy: destroySwipe, centerChild: centerChild};
    window.addEventListener('resize', onResize);
    var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    var swipes = [];

    function onResize() {
        var i;
        for (i = 0; i < swipes.length; i++) {
            initParams(swipes[i].elem, swipes[i], true);
        }
    }

    function initParams(elem, swipable) {
        swipable.max = Math.max(getFullWidth(elem) - elem.parentNode.offsetWidth + 8, 0);
    }

    function initSwipe(elem, onChildClick, onDoubleClick = () => {}) {
        if(elem.classList.contains('swipable')) {
            return;
        }
        var resSwipe = {};
        var onMove = onPanMove.bind(null, resSwipe);
        initParams(elem, resSwipe);

        elem.classList.add('swipable');
        resSwipe.elem = elem;
        resSwipe.onStart = onPanStart.bind(null, resSwipe);
        resSwipe.onMove = throttle(onMove, isFirefox ? 30 : 15);
        resSwipe.onEnd = onPanEnd.bind(null, resSwipe);

        var resTap;
        resSwipe.taps = [];

        for(var i = elem.children.length - 1; i >= 0 ; i--) {
            resTap = {};
            resTap.elem = elem.children[i];
            resTap.onDown = onChildDown.bind(null, resTap);
            resTap.onUp = onChildUp.bind(null, resTap, onChildClick);
            resTap.elem.addEventListener('mousedown', resTap.onDown);
            resTap.elem.addEventListener('touchstart', resTap.onDown);
            resSwipe.taps.push(resTap);
        }

        elem.addEventListener('mousedown', resSwipe.onStart, true);
        elem.addEventListener('touchstart', resSwipe.onStart, true);
        swipes.push(resSwipe);
    }

    function onChildDown(tappable, e) {
        stopPropagation(e);
        tappable.startX = getCoord(e, 'x');
        tappable.startY = getCoord(e, 'y');
        tappable.startTime = performance.now();

        tappable.elem.addEventListener('mouseup', tappable.onUp);
        tappable.elem.addEventListener('touchend', tappable.onUp);
    }

    function onChildUp(tappable, callback, e) {
        stopPropagation(e);
        var timeDiff = performance.now() - tappable.startTime;
        var dx = getCoord(e, 'x') - tappable.startX, dy = getCoord(e, 'y') - tappable.startY;
        if(Math.pow(dx * dx + dy * dy, .5) < 6 && timeDiff < 500) {
            callback(tappable.elem, e);
        }

        tappable.elem.removeEventListener('mouseup', tappable.onUp);
        tappable.elem.removeEventListener('touchend', tappable.onUp);
    }

    function centerChild(elem, child) {
        var swipable = swipes.filter(function(s) {return s.elem == elem})[0];
        move(elem, child.offsetLeft - elem.firstChild.offsetLeft + (child.offsetWidth / 2) - (elem.parentNode.offsetWidth / 2), swipable, true);
    }

    function destroySwipe(elem) {
        var swipable = swipes.filter(function(s) {return s.elem == elem})[0];
        if(!swipable) {
            return;
        }
        elem.removeEventListener('mousedown', swipable.onStart, true);
        elem.removeEventListener('touchstart', swipable.onStart, true);
        document.removeEventListener('mousemove', swipable.onMove, true);
        document.removeEventListener('touchmove', swipable.onMove, true);
        document.removeEventListener('mouseup', swipable.onEnd, true);
        document.removeEventListener('touchend', swipable.onEnd, true);
        for(var i = 0 ; i < swipable.taps.length; i++) {
            destroyTap(swipable.taps[i]);
        }
        swipable.taps = null;
        elem.classList.remove('swipable');
        swipes.splice(swipes.indexOf(swipable), 1);
        window.removeEventListener('resize', onResize);
    }

    function destroyTap(tap) {
        tap.elem.removeEventListener('mousedown', tap.onDown);
        tap.elem.removeEventListener('touchstart', tap.onDown);
        tap.elem.removeEventListener('mouseup', tap.onUp);
        tap.elem.removeEventListener('touchend', tap.onUp);
    }

    function onPanStart(swipable, e) {
        swipable.start = getCoord(e, 'x');
        var elem = swipable.elem;
        initParams(elem, swipable);
        swipable.moving = true;
        swipable.startScroll = swipable.offset;
        elem.classList.add('swiping');
        document.addEventListener('mousemove', swipable.onMove, true);
        document.addEventListener('touchmove', swipable.onMove, true);
        document.addEventListener('mouseup', swipable.onEnd, true);
        document.addEventListener('touchend', swipable.onEnd, true);
    }

    function getCoord(e, axis) {
        axis = axis.toUpperCase();
        var prop = 'client' + axis, altProp = 'page' + axis;
        e = ['touchstart', 'touchmove'].indexOf(e.type) > -1 ? e.touches[0] : e.type == 'touchend' ? e.changedTouches[0] : e;
        return typeof e[prop] !== 'undefined' ? e[prop] : e[altProp];
    }

    function onPanMove(swipable, e) {
        var elem, res;
        if (swipable.moving) {
            var delta = getCoord(e, 'x') - swipable.start;
            elem = swipable.elem;
            res = swipable.startScroll - delta;
            if(Math.abs(res) > 3) {
                move(elem, res, swipable);
            }
        }
    }

    function onPanEnd(swipable, e) {
        var elem = swipable.elem;
        if (!swipable.moving) {
            return;
        }
        swipable.start = null;
        swipable.moving = null;
        swipable.startScroll = null;
        elem.classList.remove('swiping');
        move(elem, swipable.offset, swipable, true);
        document.removeEventListener('mousemove', swipable.onMove, true);
        document.removeEventListener('touchmove', swipable.onMove, true);
        document.removeEventListener('mouseup', swipable.onEnd, true);
        document.removeEventListener('touchend', swipable.onEnd, true);
    }

    function move(elem, offset, swipable, useLimits) {
        var max;
        if(useLimits) {
            max = swipable.max || 0;
            offset = Math.min(max, Math.max(0, offset));
        }
        swipable.offset = offset;
        transform.transform(elem, -offset, 0, 0);
        // elem.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';
        // elem.firstChild.style.transform = 'translateX(' + -offset + 'px)';
    }

    function getFullWidth(elem) {
        if (!elem.firstChild) {
            return 0;
        }
        return elem.lastChild.offsetLeft - elem.firstChild.offsetLeft + elem.lastChild.offsetWidth;
    }

    function stopPropagation(e) {
        e.stopPropagation();
        e.preventDefault();
    }
})();
